export const amountPattern = /^\$?(\d{1,7}(\.(\d\d))?)$/;
